<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title
        >角色管理
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>
          <el-button
            v-if="operationSuper.删除"
            class="g-form-section-search operate__item"
            title="删除"
            icon="e6-icon-clear_line"
            @click="handleBatchDeleteUser"
            plain
          ></el-button>
          <el-button
            v-if="operationSuper.编辑"
            class="g-form-section-search operate__item"
            icon="e6-icon-add_line"
            @click="$router.push('/systemSettingRoleManageEdit')"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.roleName">
            <el-input
              v-model="slotForms.forms.roleName"
              placeholder="角色名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.moduleIds">
            <el-select
              v-model="slotForms.forms.moduleIds"
              placeholder="权限"
              clearable
            >
              <el-option
                v-for="item in modules"
                :key="item.moduleId"
                :label="item.moduleName"
                :value="item.moduleId"
              ></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        element-loading-text="拼命加载中"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
          :selectable="checkboxInit"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          :prop="item.name"
          :label="item.title"
        ></el-table-column>
        <el-table-column align="center" label="操作" width="80">
          <template slot-scope="scope">
            <router-link
              v-if="operationSuper.编辑"
              :to="{
                path: '/systemSettingRoleManageEdit',
                query: { pageType: '2', roleId: scope.row.roleId }
              }"
              >编辑
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 批量删除确认 -->
    <e6-message-box
      :messageBoxVisible.sync="messageBoxVisible"
      @messageBoxSubmit="handleMessageBoxSubmit"
    >
      <div class="batch-delete">确认删除角色？</div>
    </e6-message-box>
    <!-- 批量删除确认 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
  </div>
</template>

<script>
import {
  FetchGetTableColumnSettings,
  FetchSaveUserTableColumnSettings,
  FetchGetAllModule
} from "_private/api/public.js";

import {
  FetchGetExtColumn,
  FetchFindByPage,
  FetchDeleteUser
} from "_private/api/systemSetting/roleManage";

import { mapGetters, mapActions } from "vuex";

import resizeListener from "_private/mixins/resizeListener";
import { mergeFormExtend } from "_private/utils/merge";
import operationManage from "_private/mixins/operationManage";

export default {
  mixins: [resizeListener, operationManage],
  data() {
    return {
      tableLoading: false,
      isSearch: false,
      total: 0,
      curPage: 1,
      pageSize: 20,
      formExtend: {
        forms: {
          roleName: "",
          moduleIds: ""
        },
        extends: []
      },
      tableData: [],
      columSetVisible: false,
      showTableCols: [],
      hideTableCols: [],
      copyShowTableCols: [],
      copyHideTableCols: [],
      localShowTableCols: [],
      multipleSelection: [],
      messageBoxVisible: false,
      modules: []
    };
  },
  computed: {
    ...mapGetters(["moduleId", "userId", "searchFormIsOpen"]),
    roleIds() {
      let ids = this.multipleSelection.map(item => {
        return item.roleId;
      });
      return ids.length < 1 ? "" : ids.join(",");
    },
    columnStr() {
      let columnStr = this.copyShowTableCols.map(item => {
        return item.name;
      });
      return columnStr.length < 1 ? "" : columnStr.join(",");
    }
  },
  created() {
    this.FetchGetExtColumn({ edit: false, moduleId: this.moduleId });
    this.FetchTableColumnDataAndTableData(
      { userId: this.userId, moduleId: this.moduleId },
      this.mergeObj()
    );
    this.FetchGetAllModule();
    this.setSearchFormIsOpenAct();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),

    checkboxInit(row) {
      return row.roleId === 1 ? 0 : 1;
    },
    // 获取表格列数据和表格数据
    FetchTableColumnDataAndTableData(tableColumnData, tableData) {
      this.tableLoading = true;
      Promise.all([
        FetchGetTableColumnSettings(tableColumnData),
        FetchFindByPage(tableData)
      ])
        .then(([tableColumnResponse, tableResponse]) => {
          this.setTableColumnData(tableColumnResponse);
          this.setTableData(tableResponse);
          this.tableLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 设置表格列数据
    setTableColumnData(response) {
      let showTableCols = [];
      let hideTableCols = [];
      if (response.result && Array.isArray(response.result)) {
        response.result.forEach(item => {
          if (item.show) {
            showTableCols.push(item);
          } else {
            hideTableCols.push(item);
          }
        });
      }
      this.showTableCols = showTableCols;
      this.hideTableCols = hideTableCols;
      this.copyShowTableCols = showTableCols;
      this.copyHideTableCols = hideTableCols;
      this.localShowTableCols = showTableCols;
    },
    // 设置表格数据
    setTableData(response) {
      if (
        response.result &&
        response.result.data &&
        Array.isArray(response.result.data)
      ) {
        this.tableData = response.result.data;
        this.total = response.result.totalRecords;
      }
    },
    // 获取权限列表
    FetchGetAllModule() {
      FetchGetAllModule()
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.modules = response.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取查询扩展字段
    FetchGetExtColumn(data) {
      FetchGetExtColumn(data)
        .then(response => {
          if (response.result && Array.isArray(response.result)) {
            this.formExtend.extends.push(...response.result);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取表格数据
    FetchFindByPage(data) {
      this.tableLoading = true;
      FetchFindByPage(data)
        .then(response => {
          this.setTableData(response);
          this.tableLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取表格列列表
    FetchGetTableColumnSettings(data) {
      this.tableLoading = true;
      FetchGetTableColumnSettings(data)
        .then(response => {
          this.setTableColumnData(response);
          this.tableLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 修改表格列列表
    FetchSaveUserTableColumnSettings(data) {
      FetchSaveUserTableColumnSettings(data)
        .then(response => {
          let type = response.code === 1 ? "success" : "error";
          let message = response.message;
          this.$message({
            showClose: true,
            message: message,
            type: type,
            duration: 2000,
            onClose: () => {
              if (type === "success") {
                this.FetchGetTableColumnSettings({
                  moduleId: this.moduleId,
                  userId: this.userId
                });
              }
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 删除用户
    FetchDeleteUser(data) {
      FetchDeleteUser(data)
        .then(response => {
          let type = response.code === 1 ? "success" : "error";
          let message = response.message;
          this.$message({
            showClose: true,
            message: message,
            type: type,
            duration: 2000,
            onClose: () => {
              if (type === "success") {
                if (this.total % this.pageSize == 1) {
                  if (this.total != 1) {
                    this.curPage = this.curPage - 1;
                  }
                }
                this.FetchFindByPage(this.mergeObj());
              }
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        curPage: this.curPage,
        pageSize: this.pageSize
      });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },
    // 选择表格列
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 打开确认删除面板
    handleBatchDeleteUser() {
      if (this.roleIds === "") {
        return this.$message({
          showClose: true,
          message: "请最少选择一条数据！",
          type: "error",
          duration: 1200
        });
      }
      this.messageBoxVisible = true;
    },
    // 确认删除用户
    handleMessageBoxSubmit() {
      this.FetchDeleteUser({ roleIds: this.roleIds });
    },
    // 取消表格列设置
    handleSetColumnCancel() {
      this.copyShowTableCols = this.showTableCols;
      this.copyHideTableCols = this.hideTableCols;
    },
    // 确认表格列设置
    handleSetColumnSubmit() {
      this.FetchSaveUserTableColumnSettings({
        moduleId: this.moduleId,
        userId: this.userId,
        columnStr: this.columnStr
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
</style>
